import { connect } from 'react-redux';
import GoogleAnalyticsApi from './GoogleAnalyticsApi';
import { getGoogleAnalyticsTrackingId } from '../../selectors/configSelectors';

const mapStateToProps = state => ({
  googleAnalyticsTrackingId: getGoogleAnalyticsTrackingId(state),
});

export default connect(mapStateToProps, {})(GoogleAnalyticsApi);



// WEBPACK FOOTER //
// ./src/components/GoogleAnalyticsApi/GoogleAnalyticsApiContainer.js